<template>
  <div>
    <b-modal
      id="modal"
      title="Eintrag ändern"
      ok-variant="success"
      ok-title="Speichern"
      cancel-variant="danger"
      cancel-title="Abbrechen"
      v-model="show"
      @hide="hideModal"
      @ok="saveEntry"
    >
      <b-form-row>
        <b-col>
          <b-form-group id="input-group-1" label="Fahrer:" label-for="input-1">
            <b-form-input
              id="input-1"
              disabled
              v-model="item.driver.full_name"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group id="input-group-1" label="Von:" label-for="input-1">
            <VueCtkDateTimePicker
              v-model="item.from_date"
              format="YYYY-MM-DD HH:mm:ss"
              locale="de"
              button-now-translation="Jetzt"
              no-label
            />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group id="input-group-1" label="Bis:" label-for="input-1">
            <VueCtkDateTimePicker
              v-model="item.to_date"
              format="YYYY-MM-DD HH:mm:ss"
              locale="de"
              button-now-translation="Jetzt"
              no-label
            />
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-modal>
  </div>
</template>

<script>
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    export default {
        name: "driverhistoryEntryChangeForm",
        components: {
            VueCtkDateTimePicker
        },
        props: {
            item: Object,
            show: {
                type: Boolean,
                required: true,
                twoWay: true
            }
        },
        methods: {
            hideModal() {
                this.$emit('update:show', false);
            },
            saveEntry() {
                this.$emit('updateEntry', this.item);
            },
        }
    }
</script>

<style scoped>

</style>
